<template>
    <div class="my-5 p-3">
        <div class="col-12 mb-5">
            <h2 v-html="header" class="text-white pb-4"></h2>
        </div>

        <h3 class="text-center text-white font-italic" v-if="events.length == 0"> <u> Aktualnie nie wziąłeś udziału w żadnym wydarzeniu. </u> </h3>

        <div v-else class="row section-events-list">
            <single-event v-for="event in events" :event="event" :key="event.name" :asset_path="asset_path" :color="'text-white'" :withYear="true"></single-event>
        </div>

        <paginator :page="page" :perPage="perPage" :pagination="pagination" :method="setPage"></paginator>

    </div>
</template>

<script>
    import paginator from './paginator.vue';

    export default {
        props: ['header', 'asset_path'],

        components: {
            paginator
        },

        data() {
            return {
                events: [],
                pagination: [],
                page: 1,
                perPage: 9,
            }
        },

        created() {
            this.fetchData();
        },

        methods: {
            fetchData() {
                axios.get('/api/user-data/events', {
                    params: {
                        page: this.page,
                    }
                })
                .then((response) => {
                    this.events = response.data.data;
                    this.pagination = response.data;
                    this.perPage = response.data.per_page;
                });
            },

            getAssetPath(path) {
                return this.asset_path + '/' + path;
            },

            setPage(page) {
                this.page = page;
                this.fetchData();
            }
        }

    }
</script>
